import { Box, Stack, Typography, Avatar, useTheme } from '@mui/material';
import { SippIcon } from '../../../../icons/SippIcon';
import { fPercent } from '../../../../../utils/formatNumber';

const ProbabilityInfoWidget = ({probability, estimatedWells}:{probability:number, estimatedWells:number}) => {
    const theme = useTheme();
  return (
    <Box
      sx={{
        width: '100%',
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: '0.75rem', 
        padding: '1rem',
      }}  
    >
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        spacing={2}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Avatar
            sx={{
              backgroundColor: theme.palette.info.light,
              width: '2rem', 
              height: '2rem',
            }}
          >
            <SippIcon />
          </Avatar>
          <Stack>
            <Typography
              fontSize="1rem"
              fontWeight="bold"
              color={theme.palette.info.main}
              sx={{ textAlign: { xs: 'center', sm: 'left' } }}
            >
              Well Water Probability
            </Typography>
            <Typography
              fontSize="0.875rem"
              color="text.secondary"
              sx={{ textAlign: { xs: 'center', sm: 'left' } }}
            > 
              Based on {Math.max(1, estimatedWells)} {estimatedWells <= 1 ? 'well' : 'wells'} in your area
            </Typography>
          </Stack>
        </Stack>

        <Stack alignItems={{ xs: 'center', sm: 'flex-end' }}>
          <Typography
            fontSize="2rem"
            fontWeight="bold"
            color="primary.main"
            sx={{ textAlign: { xs: 'center', sm: 'right' } }}
          >
            {fPercent(probability)}
          </Typography>
          <Typography
            fontSize="0.875rem"
            color="text.secondary"
            sx={{ textAlign: { xs: 'center', sm: 'right' } }}
          >
            Likelihood
          </Typography>
        </Stack>
      </Stack>

      <Typography
        fontSize="0.875rem"
        color="text.secondary"
        sx={{
          marginTop: '1rem', 
          textAlign: { xs: 'center', sm: 'left' },
        }}
      >
        With a high concentration of wells in your area, regular maintenance and water quality testing is recommended. Well water quality can vary significantly and may require specific treatment methods.
      </Typography>
    </Box>
  );
};

export default ProbabilityInfoWidget;
